<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <formace-personas
          :abrir = dialogCE
          :nuevo = esNuevo
          :datos = datos
          :titulo = tituloCE
          @keydown.esc = "dialogCE = false"
          @cerrarVentana = "dialogCE = false"
          @actualizarTabla = "initialize" />

        <other-detalles
        :abrir = dialogMI
        :datos = editedItem
        :titulo = tituloMI
        :headers = headersFull
        @keydown.esc = "dialogMI = false"
        @cerrarVentana = "dialogMI = false"
        @actualizarTabla = "initialize" />

        <material-card
          color="red darken-3"
          flat
          full-width
          title="Administracion de personas">
        
          <v-container>
            <v-layout wrap>
              <v-flex md4>
                <v-text-field
                    label = "Buscar"
                    color = "info"
                    v-model = "search"
                    append-icon="mdi-magnify"
                    placeholder="Busqueda de grupos por palabra clave"
                    hide-details
                />
              </v-flex>
              <v-flex md4>
                <v-select
                    class = "body-1"
                    :items = "['Todos','Trabajadores', 'Mentores', 'Aliados', 'Tutores']"
                    v-model = "tipoBusqueda"
                    @change = "cambiarDatos"
                    label = "Vista actual"
                    required
                ></v-select>
              </v-flex>
              <v-flex md4>
                <v-btn dark color="blue darken-1" @click="newItem()">
                  <v-icon left>mdi-account-plus</v-icon>
                  <span>Crear nueva persona</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>

          <v-data-table
            :headers = "headers"
            :items = "data"
            :search = "search"
            rows-per-page-text = "Numero de elementos para mostrar"
            sort-by="_id"
            class="elevation-1">

            <template
              slot="items"
              slot-scope="{ item }">
              <td class="text-xs-left">
                {{ item._id }}
              </td>
              <td class="text-xs-left">
                {{ item.tipo }}
              </td>
              <td class="text-xs-left">
                {{ item.nombre }}
              </td>
              <td class="text-xs-left">
                {{ item.paterno }}
              </td>
              <td class="text-xs-left">
                {{ item.materno }}
              </td>
              <td class="text-xs-left">
                {{ etiqueta(item.activo) }}
              </td>
              <td>
                <v-tooltip
                  content-class="bottom"
                  bottom>
                  <v-btn slot="activator" icon>
                    <v-icon
                      small
                      color="blue"
                      class="mr-2"
                      @click="viewItem(item)">
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                  <span>Ver ficha completa de la persona</span>
                </v-tooltip>
                <v-tooltip
                  content-class="bottom"
                  bottom>
                  <v-btn slot="activator" icon>
                    <v-icon
                      small
                      color="orange"
                      class="mr-2"
                      @click="editItem(item)">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <span>Editar información de la persona</span>
                </v-tooltip>
                <v-tooltip
                  content-class="bottom"
                  bottom>
                  <v-btn slot="activator" icon>
                    <v-icon
                      small
                      color="red"
                      class="mr-2"
                      @click="deleteItem(item)">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                  <span>Borrar persona</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import ServiceHandler from '../ServiceHandler';
  
  export default {
    data: () => ({
      headers: [
        {
          text: 'ID',
          value: '_id',
        },
        {
          text: 'Tipo de persona',
          value: 'tipo'
        },
        {
          text: 'Nombre(s)',
          value: 'nombre'
        },
        {
          text: 'Paterno',
          value: 'paterno'
        },
        {
          text: 'Materno',
          value: 'materno'
        },
        {
          text: '¿Disponible?',
          value: 'activo'
        },
        {
          text: 'Acciones',
          sortable: false,
        }
      ],
      headersFull: [
        {
          text: 'ID de persona',
          value: '_id',
        },
        {
          text: 'Tipo de persona',
          value: 'tipo'
        },
        {
          text: 'Nombre(s)',
          value: 'nombre'
        },
        {
          text: 'Ap. Paterno',
          value: 'paterno'
        },
        {
          text: 'Ap. Materno',
          value: 'materno'
        },
        {
          text: 'Telefono',
          value: 'telefono'
        },
        {
          text: 'Extension',
          value: 'ext'
        },
        {
          text: 'Celular',
          value: 'celular'
        },
        {
          text: 'Informacion adicional',
          value: 'infoadicional'
        },
      ],
      datos: {},
      search: "",

      esNuevo: true,
      tituloCE: '',
      dialogCE: false,
      dialogMI: false,
      titloMI: '',
      tipoBusqueda: 'Todos',
      
      data: [],     
      editedIndex: -1,
      editedItem: {
        _id: '',
        tipo: '',
        nombre: '',
        paterno: '',
        materno: '',
        telefono: '',
        ext: '',
        celular: '',
        infoadicional: '',
        activo: '',
      },
      defaultItem: {
        _id: '',
        tipo: '',
        nombre: '',
        paterno: '',
        materno: '',
        telefono: '',
        ext: '',
        celular: '',
        infoadicional: '',
        activo: '',
      },
    }),   

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        try{
          this.data = await ServiceHandler.getElements("personas");
        }catch(e){
          this.error = e.message;
        }
      },
      async cambiarDatos(){
        //console.log("tipoBusqueda: " + this.tipoBusqueda);
        try{
          if(this.tipoBusqueda == "Todos"){
            this.data = await ServiceHandler.getElements("personas");
          }else{
            this.data = await ServiceHandler.getElements(`personas/${this.tipoBusqueda}`);
          }
        }catch(e){
          this.error = e.message;
        }
      },
      etiqueta(valor){
        console.log("valor de activo: " + valor);
        if(valor == true){
          return "Si"
        }else{
          return "No"
        }
      },
      newItem(){
        this.datos = this.defaultItem;
        this.esNuevo = true;
        this.tituloCE = "Crear nueva persona";
        this.dialogCE = true;
      },
      async viewItem (item) {
        this.editedIndex = this.data.indexOf(item);
        this.editedItem = Object.assign({}, item);
        
        this.tituloMI = `Detalles de la persona con id ${item._id}` 
        this.dialogMI = true;
        
      },

      async editItem (item) {
        this.editedIndex = this.data.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.datos = this.editedItem;
        this.esNuevo = false;
        this.tituloCE = `Edicion la persona con ID ${this.datos._id}`;
        this.dialogCE = true;
      },

      deleteItem (item) {
        const index = this.data.indexOf(item)
        confirm(`Se procederá a borrar definitivamente la persona con ID ${item._id}. ¿Desea continuar?`) && this.borrarElemento(item._id, index);
      },

      async borrarElemento(id, index){
        try{
            await ServiceHandler.deleteElement("personas", id);
            alert("Se eliminó la persona seleccionada con ID " + id);
            this.data.splice(index, 1)
          }catch(e){
            this.error = e.message;
          }
      },

      close () {
        this.dialogCE = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        if (this.editedIndex > -1) {
          //Edicion - UPDATE
          try{
            await ServiceHandler.updateElement("grupos", this.editedItem);
            initialize();
          }catch(e){
            alert("Error al procesar elementos de esta forma. " + e.message);
          }
        } else {
          //NUEVO ELEMENTO
          try{
            await ServiceHandler.insertElement("grupos", this.editedItem);
            initialize();
          }catch(e){
            alert("Error al procesar elementos de esta forma. " + e.message);
          }
        }
        this.close()
      },
    }
  }
</script>